/**
 * Norsk → Dansk. Bygget av `npm run i18n`.
 *
 * Nøkkelen er den norske teksten slik den står i koden. Verdier kan rettes
 * for hånd - skriptet oversetter kun tekster som mangler, og rører aldri en
 * verdi som allerede står her. Fila skrives om i sin helhet ved hver kjøring,
 * så egne kommentarer inni lista forsvinner.
 */
export const name = 'Dansk'

export const strings = {
  '-knappen nederst': '-knappen nederst',
  '{amount} er lagt til sparegrisen din.': '{amount} er lagt til din sparegris.',
  '{amount} er trukket fra. Du har {balance} igjen.':
    '{amount} er trukket fra. Du har {balance} tilbage.',
  '{amount1} venter på godkjenning — du har {amount2} å bruke av':
    '{amount1} venter på godkendelse — du har {amount2} at bruge af',
  '{count} ganger': '{count} gange',
  '{count} ganger per dag': '{count} gange om dagen',
  '{count} ganger per uke': '{count} gange om ugen',
  '{days} {unit} igjen': '{days} {unit} tilbage',
  '{n} denne uka': '{n} denne uge',
  '{n} kjøp': '{n} køb',
  '{n} stjerner': '{n} stjerner',
  '{n} totalt': '{n} i alt',
  '{stars} stjerner på {count} ganger': '{stars} stjerner på {count} gange',
  '{stars} stjerner totalt': '{stars} stjerner i alt',
  '{used}/{limit} brukt': '{used}/{limit} brugt',
  '1 gang per dag': '1 gang om dagen',
  '1 gang per uke': '1 gang om ugen',
  '1 stjerne = {sum}': '1 stjerne = {sum}',
  'Aldri': 'Aldrig',
  'Alle': 'Alle',
  'Alle barna': 'Alle børnene',
  'Alle bidrar mot samme tall. Ingen taper.': 'Alle bidrager til samme tal. Ingen taber.',
  'Alltid': 'Altid',
  'alt lagres kun i denne nettleseren.': 'alt gemmes kun i denne browser.',
  'Alt på plass, gulvet fritt': 'Alt på plads, gulvet frit',
  'Alt som har gått inn og ut.': 'Alt der er gået ind og ud.',
  'Angre': 'Fortryd',
  'Angre utbetaling': 'Fortryd udbetaling',
  'Angre utbetalingen? Beløpet trekkes fra saldoen igjen.':
    'Fortryd udbetalingen? Beløbet trækkes fra saldoen igen.',
  'Annet': 'Andet',
  'Antall stjerner familien skal samle til sammen.': 'Antal stjerner familien skal samle i alt.',
  'automatisk': 'automatisk',
  'Avbryt': 'Annuller',
  'Avslutt': 'Afslut',
  'Avvis': 'Afvis',
  'Avvist': 'Afvist',
  'Bare nysgjerrig?': 'Bare nysgerrig?',
  'Bare over et beløp': 'Kun over et beløb',
  'Barn': 'Børn',
  'Barna': 'Børnene',
  'Barnas lommepengekonto — der de lærer å tjene, spare og bruke egne penger. Med gjøremål, stjerner og oversikt for hele familien.':
    'Børnenes lommepengekonto — hvor de lærer at tjene, spare og bruge egne penge. Med gøremål, stjerner og overblik for hele familien.',
  'barnet': 'barnet',
  'Barnet bruker denne sammen med familiekoden.': 'Barnet bruger denne sammen med familiekoden.',
  'Barnet deltar ikke i denne utfordringen': 'Barnet deltager ikke i denne udfordring',
  'Barnet fører opp hva det har brukt og på hva, og ser sin egen forbruksoversikt. Ingen kan føre seg under null.':
    'Barnet registrerer hvad det har brugt og på hvad, og ser sit eget forbrugsoverblik. Ingen kan komme under nul.',
  'Barnet må ha et navn': 'Barnet skal have et navn',
  'Beløp ({currency})': 'Beløb ({currency})',
  'Beløpet kan ikke være null': 'Beløbet kan ikke være nul',
  'Beløpet legges til saldoen.': 'Beløbet lægges til saldoen.',
  'Beløpet trekkes fra saldoen. Skriv det positivt.':
    'Beløbet trækkes fra saldoen. Skriv det positivt.',
  'Beskrivelse': 'Beskrivelse',
  'Beskrivelse (valgfritt)': 'Beskrivelse (valgfrit)',
  'Betalingsgrensen er brukt opp. Stjernene føres som vanlig, men uten penger.':
    'Betalingsgrænsen er brugt op. Stjernerne føres som normalt, men uden penge.',
  'Bla ned og velg': 'Rul ned og vælg',
  'Bli med': 'Vær med',
  'Bok eller tegneserie teller': 'Bog eller tegneserie tæller',
  'Bra jobba!': 'Flot klaret!',
  'Bruk minus for å trekke fra, f.eks. -50.': 'Brug minus for at trække fra, f.eks. -50.',
  'Bruk oppgavelista for oppgaver': 'Brug opgavelisten til opgaver',
  'Brukeren mangler innlogging': 'Brugeren mangler login',
  'Brukt denne måneden': 'Brugt denne måned',
  'Brukt penger': 'Brugte penge',
  'Brukt til sammen': 'Brugt i alt',
  'Bursdagspenger fra bestemor': 'Fødselsdagspenge fra mormor',
  'Bytt familie': 'Skift familie',
  'Bøker': 'Bøger',
  'Da har du {amount} igjen.': 'Så har du {amount} tilbage.',
  'Da åpnes den som en vanlig app, uten nettleserlinje.':
    'Så åbner den som en almindelig app, uden browserlinje.',
  'dag': 'dag',
  'dager': 'dage',
  'data lagres kun i denne nettleseren': 'data gemmes kun i denne browser',
  'deg': 'dig',
  'Dekke bordet': 'Dække bord',
  'Del': 'Del',
  'Del denne koden med den andre forelderen:': 'Del denne kode med den anden forælder:',
  'Demomodus': 'Demotilstand',
  'Den {day}.': 'Den {day}.',
  'Denne er allerede behandlet': 'Denne er allerede behandlet',
  'Denne må godkjennes av en voksen først.': 'Denne skal godkendes af en voksen først.',
  'Denne måneden': 'Denne måned',
  'Denne oppgaven er tildelt noen andre': 'Denne opgave er tildelt en anden',
  'denne uka': 'i denne uge',
  'Det finnes allerede en konto med denne e-posten':
    'Der findes allerede en konto med denne e-mail',
  'Dette angrer kjøpet barnet førte opp. Fortsette?':
    'Dette fortryder købet barnet registrerede. Fortsæt?',
  'Dette angrer også oppgaven barnet registrerte. Fortsette?':
    'Dette fortryder også opgaven barnet afkrydsede. Fortsæt?',
  'Dette er allerede behandlet': 'Dette er allerede behandlet',
  'Dette må en voksen godkjenne først.': 'Dette skal en voksen godkende først.',
  'Ditt navn': 'Dit navn',
  'Du er allerede med i en familie': 'Du er allerede med i en familie',
  'Du er logget inn via lenka i e-posten.': 'Du er logget ind via linket i e-mailen.',
  'Du er på {place}. plass': 'Du er på {place}. plads',
  'Du har': 'Du har',
  'Du har alt fått penger for denne {limit} ganger {when}. Den teller fortsatt, og gir stjerner.':
    'Du har allerede fået penge for denne {limit} gange {when}. Den tæller stadig og giver stjerner.',
  'Du har ikke brukt noe ennå.': 'Du har ikke brugt noget endnu.',
  'Du har ikke så mye igjen': 'Du har ikke så meget tilbage',
  'Du kan fortsatt angre en føring i kontoutskriften.':
    'Du kan stadig fortryde en postering i kontoudtoget.',
  'Du leder — delt førsteplass!': 'Du fører — delt førsteplads!',
  'Du leder!': 'Du fører!',
  'E-post': 'E-mail',
  'En voksen kan lage en — for eksempel en lesekonkurranse.':
    'En voksen kan lave en — for eksempel en læsekonkurrence.',
  'Endre': 'Rediger',
  'Endre →': 'Rediger →',
  'Endre barn': 'Rediger barn',
  'Endre kategori': 'Rediger kategori',
  'Endre oppgave': 'Rediger opgave',
  'Endre postering': 'Ret postering',
  'Endre utfordring': 'Rediger udfordring',
  'Endrer bare pengene. Stjernene barnet fikk står som de er.':
    'Ændrer kun pengene. Stjernerne barnet fik står, som de er.',
  'Endringen gjelder framover. Allerede godkjente oppgaver beholder sin verdi.':
    'Ændringen gælder fremover. Allerede godkendte opgaver beholder deres værdi.',
  'Er den av, går stjernene rett inn på saldoen når barnet huker av.':
    'Er den slået fra, går stjernerne direkte ind på saldoen, når barnet krydser af.',
  'Et felles mål må ha et måltall': 'Et fælles mål skal have et måltal',
  'Etterpå oppretter du en ny familie, eller blir med i en du har fått invitasjonskode til.':
    'Bagefter opretter du en ny familie, eller bliver en del af en, du har fået en invitationskode til.',
  'F.eks. «gjort mens mobilen lå til lading»': 'F.eks. «gjort mens mobilen lå til opladning»',
  'F.eks. «hvem leser mest fram til jul», et felles mål familien jobber mot, eller et personlig mål for hvert barn.':
    'F.eks. «hvem læser mest frem til jul», et fælles mål familien arbejder mod, eller et personligt mål for hvert barn.',
  'F.eks. «tok også under senga»': 'F.eks. «tog også under sengen»',
  'F.eks. ukelønn eller gave.': 'F.eks. ugepenge eller gave.',
  'Familie': 'Familie',
  'Familiekode — barna bruker denne for å logge inn':
    'Familiekode — børnene bruger denne til at logge ind',
  'Familien': 'Familien',
  'Familienavn': 'Familienavn',
  'Fant ikke barnet': 'Fandt ikke barnet',
  'Fant ikke oppgaven': 'Fandt ikke opgaven',
  'Fant ikke posteringen': 'Fandt ikke posteringen',
  'Fant ikke registreringen': 'Fandt ikke registreringen',
  'Fant ikke utfordringen': 'Fandt ikke udfordringen',
  'Fant ikke uttaket': 'Fandt ikke købet',
  'Fant ingen familie med den koden': 'Fandt ingen familie med den kode',
  'Fant ingen språk som matcher søket.': 'Fandt ingen sprog der matcher søgningen.',
  'Fant ingen utbetaling å angre': 'Fandt ingen udbetaling at fortryde',
  'Farge': 'Farve',
  'Farge {color}': 'Farve {color}',
  'Fast beløp': 'Fast beløb',
  'Fast lommepenger': 'Faste lommepenge',
  'Fast lommepenger som ble satt inn automatisk.': 'Faste lommepenge, der blev sat ind automatisk.',
  'Faste lommepenger må være mer enn null': 'Faste lommepenge skal være mere end nul',
  'Feil e-post eller passord': 'Forkert e-mail eller adgangskode',
  'Feil PIN-kode': 'Forkert PIN-kode',
  'Felles mål': 'Fælles mål',
  'Felles måltall': 'Fælles måltal',
  'Ferdig': 'Færdig',
  'Ferdige': 'Færdige',
  'Figur': 'Figur',
  'for {count} min siden': 'for {count} min siden',
  'for {count} t siden': 'for {count} t siden',
  'For foreldre': 'For forældre',
  'Forelder': 'Forælder',
  'Foreldrene dine har slått av at du kan føre opp kjøp selv':
    'Dine forældre har slået fra, at du selv kan registrere køb',
  'Fortsett': 'Fortsæt',
  'Fra': 'Fra',
  'Fredag': 'Fredag',
  'Fritt opp til ({currency})': 'Frit op til ({currency})',
  'Følger stjernekursen': 'Følger stjernekursen',
  'Før opp kjøpet': 'Registrer købet',
  'Føres som godkjent med én gang.': 'Føres som godkendt med det samme.',
  'Ført opp!': 'Registreret!',
  'Gangene utover dette gir stjerner, men ingen penger. Nyttig i utfordringer, der alt barnet gjør skal telle.':
    'Gangene ud over dette giver stjerner, men ingen penge. Nyttigt i udfordringer, hvor alt barnet gør skal tælle.',
  'Gave til noen': 'Gave til nogen',
  'Gir': 'Giver',
  'gir bare stjerner nå': 'giver kun stjerner nu',
  'gir ingen stjerner': 'giver ingen stjerner',
  'Gjøremål': 'Gøremål',
  'Gjøremålet er registrert': 'Gøremålet er registreret',
  'Glemt passord?': 'Glemt adgangskode?',
  'Godkjenn': 'Godkend',
  'Godkjent': 'Godkendt',
  'Godteri': 'Slik',
  'Går ikke lenger enn den 28., slik at februar aldri hopper over en utbetaling.':
    'Går ikke længere end den 28., så februar aldrig springer en udbetaling over.',
  'Har du allerede konto?': 'Har du allerede en konto?',
  'Har du ikke konto?': 'Har du ikke en konto?',
  'Har invitasjon': 'Har invitation',
  'Hei, {name}!': 'Hej, {name}!',
  'Hei!': 'Hej!',
  'Hele appen vises på dette språket for hele familien':
    'Hele appen vises på dette sprog for hele familien',
  'Hele tiden': 'Hele tiden',
  'Historikk': 'Historik',
  'Hjemme': 'Hjemme',
  'Hva er én stjerne verdt? ({currency})': 'Hvad er én stjerne værd? ({currency})',
  'Hva gikk pengene til?': 'Hvad gik pengene til?',
  'Hva kjøpte du? (valgfritt)': 'Hvad købte du? (valgfrit)',
  'Hva skal gjøres?': 'Hvad skal der gøres?',
  'Hvem er du?': 'Hvem er du?',
  'Hvem er med?': 'Hvem er med?',
  'Hvem kan gjøre den?': 'Hvem kan gøre den?',
  'Hvem leser mest?': 'Hvem læser mest?',
  'Hver gang': 'Hver gang',
  'Hver måned': 'Hver måned',
  'Hver uke': 'Hver uge',
  'Hvert barn får sitt eget tall, og rangeres på hvor langt de er kommet mot sitt. Jevner ut aldersforskjeller.':
    'Hvert barn får sit eget tal, og rangeres efter hvor langt de er nået mod deres. Udligner aldersforskelle.',
  'Hvilke oppgaver teller?': 'Hvilke opgaver tæller?',
  'Hvilken dag?': 'Hvilken dag?',
  'Hvilken dato?': 'Hvilken dato?',
  'Hvor mye brukte du?': 'Hvor meget brugte du?',
  'Hvor ofte gir den penger?': 'Hvor ofte giver den penge?',
  'Hvor ofte kan den gjøres?': 'Hvor ofte kan den gøres?',
  'i dag': 'i dag',
  'I dag {time}': 'I dag {time}',
  'I går {time}': 'I går {time}',
  'Ikke innlogget': 'Ikke logget ind',
  'Ikke nå': 'Ikke nu',
  'Ikon': 'Ikon',
  'Ingen': 'Ingen',
  'Ingen barn er lagt til ennå.': 'Ingen børn tilføjet endnu.',
  'Ingen barn er lagt til i denne familien ennå.': 'Ingen børn er tilføjet i denne familie endnu.',
  'Ingen barn lagt til ennå.': 'Ingen børn tilføjet endnu.',
  'Ingen gjøremål her ennå.': 'Ingen gøremål her endnu.',
  'Ingen gjøremål registrert ennå. Trykk på knappen over for å komme i gang!':
    'Ingen gøremål registreret endnu. Tryk på knappen ovenfor for at komme i gang!',
  'Ingen gjøremål å velge mellom.': 'Ingen gøremål at vælge imellem.',
  'Ingen mål': 'Intet mål',
  'Ingen oppgaver ennå.': 'Ingen opgaver endnu.',
  'Ingen oppgaver her.': 'Ingen opgaver her.',
  'Ingen posteringer ennå.': 'Ingen posteringer endnu.',
  'Ingen stjerner samlet i perioden — ingen vinner å kåre.':
    'Ingen stjerner samlet i perioden — ingen vinder at kåre.',
  'Ingen utfordringer akkurat nå.': 'Ingen udfordringer lige nu.',
  'Ingen utfordringer ennå.': 'Ingen udfordringer endnu.',
  'Ingenting har skjedd ennå.': 'Der er ikke sket noget endnu.',
  'Innloggingen er ikke gyldig lenger. Logg ut og inn på nytt.':
    'Dit login er ikke gyldigt længere. Log ud og ind igen.',
  'Innskudd': 'Indbetaling',
  'Innstillinger': 'Indstillinger',
  'Installer': 'Installer',
  'Invitasjonskode': 'Invitationskode',
  'Inviter med-forelder': 'Inviter medforælder',
  'Is på butikken': 'Is i butikken',
  'Ja, barna kan trekke fra selv': 'Ja, børnene kan trække fra selv',
  'Ja, jeg har gjort det!': 'Ja, jeg har gjort det!',
  'Jeg er barn': 'Jeg er barn',
  'Jeg er forelder': 'Jeg er forælder',
  'Jeg har brukt penger': 'Jeg har brugt penge',
  'Kan barna føre opp egne kjøp?': 'Kan børnene registrere egne køb?',
  'Kategori': 'Kategori',
  'Kategorien trenger et navn': 'Kategorien skal have et navn',
  'Kiosk på fotballcup': 'Kiosk til fodboldstævne',
  'Kjøkken': 'Køkken',
  'Kjøp over dette beløpet havner til godkjenning hos deg.':
    'Køb over dette beløb havner til godkendelse hos dig.',
  'Kjøp til godkjenning ({count})': 'Køb til godkendelse ({count})',
  'Klarte ikke å hente historikken.': 'Kunne ikke hente historikken.',
  'Klarte ikke å hente kontoutskriften.': 'Kunne ikke hente kontoudtoget.',
  'Klarte ikke å logge inn. Prøv igjen.': 'Kunne ikke logge ind. Prøv igen.',
  'Klær': 'Tøj',
  'Kommer av seg selv, i tillegg til det barnet tjener på gjøremål.':
    'Kommer af sig selv, ud over det barnet tjener på pligter.',
  'Konkurranser og mål du er med i.': 'Konkurrencer og mål du er med i.',
  'Konkurranser og mål over tid': 'Konkurrencer og mål over tid',
  'Kontoutskrift': 'Kontoudtog',
  'Kopier': 'Kopier',
  'Kopiert': 'Kopieret',
  'Korriger': 'Korriger',
  'Korriger saldo': 'Ret saldo',
  'Korrigering': 'Korrektion',
  'krever godkjenning': 'kræver godkendelse',
  'Krever godkjenning': 'Kræver godkendelse',
  'kun': 'kun',
  'Kun': 'Kun',
  'Kun barn bruker denne': 'Kun børn bruger denne',
  'Kun barn kan registrere oppgaver': 'Kun børn kan registrere opgaver',
  'Kun foreldre kan angre': 'Kun forældre kan fortryde',
  'Kun foreldre kan angre utbetaling': 'Kun forældre kan fortryde udbetaling',
  'Kun foreldre kan endre beløp': 'Kun forældre kan ændre beløb',
  'Kun foreldre kan endre posteringer': 'Kun forældre kan ændre posteringer',
  'Kun foreldre kan endre saldo': 'Kun forældre kan ændre saldoen',
  'Kun foreldre kan gjøre dette': 'Kun forældre kan gøre dette',
  'Kun foreldre kan godkjenne': 'Kun forældre kan godkende',
  'Kun foreldre kan invitere': 'Kun forældre kan invitere',
  'Kun foreldre kan lage utfordringer': 'Kun forældre kan lave udfordringer',
  'Kun foreldre kan registrere for et barn': 'Kun forældre kan registrere for et barn',
  'Kun foreldre kan sette lommepenger': 'Kun forældre kan sætte lommepenge',
  'Kun foreldre kan slette': 'Kun forældre kan slette',
  'Kun foreldre kan slette utfordringer': 'Kun forældre kan slette udfordringer',
  'Kun foreldre kan utbetale premie': 'Kun forældre kan udbetale præmie',
  'Kunne ikke kopiere': 'Kunne ikke kopiere',
  'Lag den første': 'Lav den første',
  'Lagre': 'Gem',
  'Lagret': 'Gemt',
  'Lagret!': 'Gemt!',
  'Lar du feltet stå tomt, vises hva slags postering det er.':
    'Lader du feltet stå tomt, vises hvilken slags postering det er.',
  'Leder': 'Fører',
  'Legg Bonto på hjemskjermen': 'Føj Bonto til hjemmeskærmen',
  'Legg til': 'Tilføj',
  'Legg til barn': 'Tilføj barn',
  'Legg til barn i familien først.': 'Tilføj et barn til familien først.',
  'Legg til på Hjem-skjerm': 'Føj til hjemmeskærm',
  'Leker': 'Legetøj',
  'Lese 15 minutter': 'Læse 15 minutter',
  'Lesekonkurranse': 'Læsekonkurrence',
  'Logg inn': 'Log ind',
  'Logg inn som forelder med hva som helst, eller prøv barneinnlogging med familiekode':
    'Log ind som forælder med hvad som helst, eller prøv barnelogin med familiekode',
  'Logg ut': 'Log ud',
  'Lommepenger': 'Lommepenge',
  'Lukk': 'Luk',
  'Lørdag': 'Lørdag',
  'Mamma eller pappa må si ok før stjernene blir til penger.':
    'Mor eller far skal sige ok, før stjernerne bliver til penge.',
  'Mandag': 'Mandag',
  'Mat og drikke': 'Mad og drikke',
  'Min profil': 'Min profil',
  'Min side': 'Min side',
  'Minst 8 tegn': 'Mindst 8 tegn',
  'Må du godkjenne?': 'Skal du godkende?',
  'Mål': 'Mål',
  'Målet ble ikke nådd. Du kan likevel utbetale premien manuelt under.':
    'Målet blev ikke nået. Du kan stadig udbetale præmien manuelt nedenfor.',
  'Målet er nådd!': 'Målet er nået!',
  'Måltall': 'Måltal',
  'Måltallet er hvor mange stjerner barnet skal samle.':
    'Måltallet er, hvor mange stjerner barnet skal samle.',
  'Månedslønn': 'Månedspenge',
  'Månedslønn {amount}': 'Månedspenge {amount}',
  'Navn': 'Navn',
  'Navnet ditt og PIN-koden endres av en voksen.': 'Dit navn og PIN-koden ændres af en voksen.',
  'neste {date}': 'næste {date}',
  'Neste utbetaling {date}': 'Næste udbetaling {date}',
  'Nesten ferdig': 'Næsten færdig',
  'Notat (valgfritt)': 'Note (valgfrit)',
  'Ny': 'Ny',
  'Ny familie': 'Ny familie',
  'Ny familie?': 'Ny familie?',
  'Ny kategori': 'Ny kategori',
  'Ny oppgave': 'Ny opgave',
  'Ny utfordring': 'Ny udfordring',
  'Ny versjon klar': 'Ny version klar',
  'Nytt passord': 'Ny adgangskode',
  'nå nettopp': 'lige nu',
  'Når barnet har brukt av sparepengene.': 'Når barnet har brugt af opsparingen.',
  'og PIN': 'og PIN',
  'Onsdag': 'Onsdag',
  'Oppdater': 'Opdater',
  'Oppgaven er ikke aktiv': 'Opgaven er ikke aktiv',
  'Oppgaven er slettet': 'Opgaven er slettet',
  'Oppgaven må gi stjerner eller penger': 'Opgaven skal give stjerner eller penge',
  'Oppgaven trenger et navn': 'Opgaven skal have et navn',
  'Oppgaver': 'Opgaver',
  'Opprett en ny familie, eller bli med i en som allerede finnes.':
    'Opret en ny familie, eller bliv en del af en der allerede findes.',
  'Opprett familie': 'Opret familie',
  'Opprett konto': 'Opret konto',
  'Oversikt': 'Oversigt',
  'Passord': 'Adgangskode',
  'Passordet er oppdatert.': 'Adgangskoden er opdateret.',
  'Passordet må ha minst 8 tegn': 'Adgangskoden skal have mindst 8 tegn',
  'Penger': 'Penge',
  'penger {count} ganger per dag': 'penge {count} gange om dagen',
  'penger {count} ganger per uke': 'penge {count} gange om ugen',
  'penger 1 gang per dag': 'penge 1 gang om dagen',
  'penger 1 gang per uke': 'penge 1 gang om ugen',
  'Per dag': 'Pr. dag',
  'Per uke': 'Pr. uge',
  'Personlig mål': 'Personligt mål',
  'PIN-kode (4 siffer)': 'PIN-kode (4 cifre)',
  'PIN-koden må være 4 siffer': 'PIN-koden skal være 4 cifre',
  'Postering': 'Postering',
  'Posteringen er endret': 'Posteringen er ændret',
  'Premie': 'Præmie',
  'Premie i {currency} (valgfritt)': 'Præmie i {currency} (valgfrit)',
  'premie utbetalt': 'præmie udbetalt',
  'Premien barnet fikk utbetalt.': 'Præmien barnet fik udbetalt.',
  'Premien er allerede utbetalt til dette barnet': 'Præmien er allerede udbetalt til dette barn',
  'Premien er utbetalt': 'Præmien er udbetalt',
  'Prøv demoen': 'Prøv demoen',
  'Prøv igjen': 'Prøv igen',
  'Pågår': 'I gang',
  'Registrer': 'Registrer',
  'Registrer et gjøremål': 'Registrer et gøremål',
  'Registrer for {name}': 'Registrer for {name}',
  'Registrer gjøremål': 'Registrer gøremål',
  'Registrert! Stjernene er dine - penger gir den ikke flere ganger nå.':
    'Registreret! Stjernerne er dine – flere penge giver den ikke lige nu.',
  'Ren konkurranse — den som samler flest stjerner vinner.':
    'Ren konkurrence — den der samler flest stjerner vinder.',
  'Rydde rommet': 'Rydde værelset',
  'Saldo': 'Saldo',
  'Saldo etter:': 'Saldo efter:',
  'Saldo nå': 'Saldo nu',
  'Saldo oppdatert': 'Saldo opdateret',
  'Se alt →': 'Se alt →',
  'Sendt inn!': 'Indsendt!',
  'Sett inn': 'Indsæt',
  'Sett inn penger': 'Indsæt penge',
  'Sett ny PIN-kode': 'Sæt ny PIN-kode',
  'Sist godkjent': 'Senest godkendt',
  'Siste dag!': 'Sidste dag!',
  'Siste registreringer': 'Seneste registreringer',
  'Sjekk e-posten din': 'Tjek din e-mail',
  'Skjul': 'Skjul',
  'Skole': 'Skole',
  'Skriv inn e-postadressen din først': 'Indtast din e-mailadresse først',
  'Skriv inn en valuta': 'Indtast en valuta',
  'Skriv inn et beløp': 'Indtast et beløb',
  'Skriv inn familiekoden': 'Indtast familiekoden',
  'Skriv inn familiekoden. Den får du av mamma eller pappa.':
    'Indtast familiekoden. Den får du af mor eller far.',
  'Skriv inn hvor mye barnet skal få': 'Skriv hvor meget barnet skal have',
  'Skriv inn hvor mye du brukte': 'Indtast hvor meget du brugte',
  'Skriv inn navnet': 'Indtast navnet',
  'Slett barn': 'Slet barn',
  'Slett kategori': 'Slet kategori',
  'Slett oppgave': 'Slet opgave',
  'Slett posteringen': 'Slet posteringen',
  'Slett utfordring': 'Slet udfordring',
  'Slette {name}? All historikk forsvinner.': 'Slet {name}? Al historik forsvinder.',
  'Slette denne oppgaven? Historikken beholdes.': 'Slet denne opgave? Historikken bevares.',
  'Slette denne posteringen?': 'Slet denne postering?',
  'Slette kategorien? Oppgavene beholdes, men mister kategori.':
    'Slet kategorien? Opgaverne bevares, men mister kategori.',
  'Slette utfordringen? Registreringene til barna beholdes.':
    'Slet udfordringen? Børnenes registreringer bevares.',
  'Slettet': 'Slettet',
  'Sluttdatoen må være etter startdatoen': 'Slutdatoen skal være efter startdatoen',
  'Smågodt': 'Slik',
  'Sparegrisen din': 'Din sparegris',
  'Spill': 'Spil',
  'Språk': 'Sprog',
  'Starter i dag': 'Starter i dag',
  'Starter om {days} {unit}': 'Starter om {days} {unit}',
  'Starter snart': 'Starter snart',
  'Startsaldo': 'Startsaldo',
  'stjernene fra disse teller i utfordringen': 'stjernerne fra disse tæller i udfordringen',
  'Stjernene teller som før i totalen og i utfordringer - men det er dette beløpet som havner på saldoen.':
    'Stjernerne tæller som før i totalen og i udfordringer - men det er dette beløb, der lander på saldoen.',
  'Stjerner': 'Stjerner',
  'stjerner totalt': 'stjerner i alt',
  'Stjerner totalt': 'Stjerner i alt',
  'Støvsuge stua': 'Støvsuge stuen',
  'Synlig for barna': 'Synlig for børnene',
  'Søk etter språk …': 'Søg efter sprog …',
  'Søndag': 'Søndag',
  'Så ofte man vil': 'Så tit man vil',
  'Ta ut': 'Hæv',
  'Ta ut penger': 'Hæv penge',
  'Tast PIN-koden din': 'Indtast din PIN-kode',
  'Til {name}': 'Til {name}',
  'til barnet.': 'til barnet.',
  'Til innlogging': 'Til login',
  'Til og med': 'Til og med',
  'Tilbake': 'Tilbage',
  'Tirsdag': 'Tirsdag',
  'tjent': 'tjent',
  'tjent i utfordringen': 'tjent i udfordringen',
  'Tok også gangen': 'Tog også gangen',
  'Torsdag': 'Torsdag',
  'Trykk': 'Tryk',
  'Trykk for å oppdatere appen.': 'Tryk for at opdatere appen.',
  'Trykk på': 'Tryk på',
  'Trykk på det du har gjort.': 'Tryk på det du har gjort.',
  'Trykk på lenka for å fullføre registreringen.': 'Tryk på linket for at fuldføre registreringen.',
  'Tømme oppvaskmaskinen': 'Tømme opvaskemaskinen',
  'Ugyldig beløpsgrense': 'Ugyldig beløbsgrænse',
  'Ugyldig eller utløpt invitasjonskode': 'Ugyldig eller udløbet invitationskode',
  'Ugyldig forespørsel': 'Ugyldig forespørgsel',
  'Ugyldig stjerneverdi': 'Ugyldig stjerneværdi',
  'Ukelønn': 'Ugepenge',
  'Ukelønn {amount}': 'Ugepenge {amount}',
  'Ukjent': 'Ukendt',
  'Ukjent bruker': 'Ukendt bruger',
  'Ukjent handling': 'Ukendt handling',
  'Utbetal {amount}': 'Udbetal {amount}',
  'Utbetale {amount} til {name}?': 'Udbetale {amount} til {name}?',
  'Utbetales manuelt av deg når utfordringen er over — da kan uavgjort håndteres som dere vil.':
    'Udbetales manuelt af dig, når udfordringen er slut — så kan uafgjort håndteres som I vil.',
  'Utbetalingen er angret': 'Udbetalingen er fortrudt',
  'Uten kategori': 'Uden kategori',
  'Utfordring': 'Udfordring',
  'Utfordringen har ingen premie': 'Udfordringen har ingen præmie',
  'Utfordringen trenger et navn': 'Udfordringen skal have et navn',
  'Utfordringer': 'Udfordringer',
  'Uttak': 'Hævning',
  'Utvendig og innvendig': 'Udvendigt og indvendigt',
  'valgt': 'valgt',
  'Valuta': 'Valuta',
  'Vaske bilen': 'Vaske bilen',
  'Vedkommende oppretter konto og velger «Har invitasjon». Koden varer i 14 dager.':
    'Personen opretter en konto og vælger «Har invitation». Koden gælder i 14 dage.',
  'velg alle': 'vælg alle',
  'Velg en dag mellom 1 og 28': 'Vælg en dag mellem 1 og 28',
  'Velg en ukedag': 'Vælg en ugedag',
  'Velg minst én oppgave som skal telle': 'Vælg mindst én opgave der skal tælle',
  'Velg minst ett barn som skal delta': 'Vælg mindst ét barn der skal deltage',
  'Velg nytt passord': 'Vælg ny adgangskode',
  'Velg språk': 'Vælg sprog',
  'Venter på at en voksen godkjenner.': 'Venter på at en voksen godkender.',
  'Venter på godkjenning': 'Venter på godkendelse',
  'Venter på godkjenning ({count})': 'Venter på godkendelse ({count})',
  'Vi har sendt deg en e-post med lenke for å velge nytt passord.':
    'Vi har sendt dig en e-mail med et link til at vælge ny adgangskode.',
  'Vi har sendt en bekreftelseslenke til': 'Vi har sendt et bekræftelseslink til',
  'Vil du logge ut?': 'Vil du logge ud?',
  'Vil du skrive noe? (valgfritt)': 'Vil du skrive noget? (valgfrit)',
  'Vis': 'Vis',
  'Vis meg hvordan': 'Vis mig hvordan',
  'Vises bak alle beløp i appen, f.eks. kr, SEK, DKK, €, $.':
    'Vises efter alle beløb i appen, f.eks. kr, SEK, DKK, €, $.',
  'Voksne': 'Voksne',
  'å bruke av.': 'at bruge af.',
}
